import {ControllableDialog, DialogController} from "./index";
import {getCookie} from "../view-script";

export default function setup(controller: DialogController): ControllableDialog {
	const form = document.getElementById("lets-get-to-know-you-better");
	if (!(form instanceof HTMLFormElement)) {
		throw new Error();
	}

	form.addEventListener('submit', async e => {
		e.preventDefault();
		e.stopPropagation();

		controller.show("whitepaper-forms-waiting");
		controller.setFormFilledOut(true);

		const resp = await fetch(form.action, {method: 'POST', body: new FormData(form)});
		if (!resp.ok) {
			//TODO: Handle errors
			return;
		}

		controller.show("please-check-your-email");
	});

	return {
		beforeShow() {
			const emailAddressElement = form.elements.namedItem("email_address");
			if (emailAddressElement instanceof HTMLInputElement) {
				emailAddressElement.value = getCookie()!;
			}
			const requestedDownloadElement = form.elements.namedItem("requested_whitepaper");
			if (requestedDownloadElement instanceof HTMLInputElement) {
				requestedDownloadElement.value = controller.activeHref!;
			}
		}
	}
}
